export function formatCPF(value) {
    var numbers = value.replace(/\D/g, "");
    if (numbers.length <= 3)
        return numbers;
    if (numbers.length <= 6)
        return "".concat(numbers.slice(0, 3), ".").concat(numbers.slice(3));
    if (numbers.length <= 9)
        return "".concat(numbers.slice(0, 3), ".").concat(numbers.slice(3, 6), ".").concat(numbers.slice(6));
    return "".concat(numbers.slice(0, 3), ".").concat(numbers.slice(3, 6), ".").concat(numbers.slice(6, 9), "-").concat(numbers.slice(9, 11));
}
